import React from 'react';
import styles from './ListItem.module.scss';

export interface ListItemInterface {
  items: Array<{
    title: string;
    description: React.ReactNode;
  }>;
}

export const ListItem = ({ items }: ListItemInterface) => (
  <div className={styles.root}>
    <ul className={styles.listContainer}>
      {items.map(item => (
        <li key={item.title} className={styles.itemContainer}>
          <div className={styles.titleContainer}>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="24" viewBox="0 0 15 24" fill="none">
                <path
                  d="M14.0463 9.48915H8.50229L10.702 0.214355L0 14.5108H5.54405L3.34437 23.7855L14.0463 9.48915Z"
                  fill="#BEA2FF"
                />
              </svg>
            </div>
            <h3 className={styles.title}>{item.title}</h3>
          </div>
          <div className={styles.descriptionContainer}>{item.description}</div>
        </li>
      ))}
    </ul>
  </div>
);
